<template>
    <div class='login-container mobile'>
        <div class='login-wrap'>
            <div class='input-area'>
                <div style='width: 100%; text-align: center'>
                    <img class='login-image' src='/img/icons/ic_login_logo.png' />
                </div>
                <div class='login-contractor'>계약자 본인 인증</div>
                <div class='login-contractor-desc'>계약서를 수신한 회원을 확인합니다.<br> 이름과 휴대폰 번호를 입력해주세요.<br> 센터에 입력된 회원 정보와 맞지 않을 경우<br>서명을 진행할 수 없습니다.</div>
                <div class='login-title'>이름</div>
                <input v-model.trim='userName'
                       autofocus
                       placeholder='이름을 입력해주세요.'
                       type='text' />
                <div class='login-title'>연락처</div>
                <input v-model.trim='phoneNumber'
                       placeholder="'-'를 제외하고 입력해주세요."
                       type='number'/>
            </div>
        </div>
        <div class='btn-area'>
            <button class='com-btn btn-mobile-login' @click='signup'>본인 인증하기</button>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import jwt_decode from 'jwt-decode';

export default {
    name: 'UserLogin',
    props: {},
    computed: {
    },
    data() {
        return {
            templateSendId: this.$route.params.uid,
            userName: '', // notbad@notbad.com
            phoneNumber: '', // 1234
        };
    },
    mounted() {
        this.uid = window.localStorage.getItem('uid');
    },
    methods: {
        testMethod(event) {
            event.target.focus();
        },
        async signup() {
            if (!this.userName || !this.phoneNumber) {
                alert("이름과 연락처를 입력해 주세요.")
                return;
            }

            await this.$store
            .dispatch('auth/loginCustomer', {
                username: this.userName,
                phonenumber: this.phoneNumber,
                type: "N",
                templateSendId: this.templateSendId
            })
            .then(() => {
                this.$router.push({
                    path: `/mobile/user/contract/${this.templateSendId}`
                });
            })
            .catch(({ message }) => {
                // alert(message);
            });
        },
    },
};
</script>
<style lang='scss'>
.login-wrap {
    width: 100%;
    margin: 0 auto 0;
    border-radius: 5px;

    .input-area {
        .ui-select {
            width: 100%;
            margin-bottom: 10px;
        }
    }

    input {
        width: 100%;

        + input {
            margin-top: 10px;
        }
    }

    .btn-area {
        margin-top: 30px;

        .com-btn {
            width: 100%;
        }
    }
}
</style>
